<template>
  <div id="CategoryComponent" class="category-layout">
    <v-card outlined
      ><v-card-title>{{ $t("vendor.headerStep2") }}</v-card-title
      ><v-card-text
        ><v-form ref="form" v-model="valid" lazy-validation>
          <v-row align="start" class="pa-4">
            <v-col cols="4">
              <v-select
                outlined
                dense
                v-model="categoryModel"
                :items="category"
                :rules="[(v) => !!v || 'Category is required']"
                label="Category"
                required
                item-text="categoryName"
                item-value="id"
              ></v-select></v-col
            ><v-col cols="4">
              <v-select
                outlined
                dense
                v-model="subCategoryModel"
                :items="subcategory"
                :rules="[(v) => !!v || 'Sub Category is required']"
                label="Sub Category"
                required
                item-text="subCategoryName"
                item-value="id"
              ></v-select></v-col
            ><v-col cols="2">
              <v-btn @click="AddVendorCat" class="primary">
                Add Category
              </v-btn></v-col
            ></v-row
          ></v-form
        >
        <v-data-table :headers="headers" :items="showTable"
          ><template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              @click="
                deleteCategory({
                  categoryId: item.categoryId,
                  subCategoryId: item.subCategoryId,
                })
              "
            >
              mdi-delete
            </v-icon>
          </template></v-data-table
        ></v-card-text
      ></v-card
    >
  </div>
</template>

<script>
import { masterservice } from "../../services/masterservice";
export default {
  name: "CategoryComponent",
  props: {
    propUserName: {
      type: String,
      default: "",
    },
    propVendorID: {
      type: Number,
      default: 0,
    },
    propVendorCatListModel: {
      type: Array,
      default: () => [],
    },
    propCheckStep: {
      type: [Number, String],
      default: () => "",
    },
  },
  data: () => ({
    // Option
    category: [],
    subcategory: [],

    // Model
    categoryModel: 0,
    subCategoryModel: 0,
    vendorCatListModel: [],
    userName: "",
    vendorId: 0,
    showTable: [],
    headers: [
      { text: "Category", value: "categoryName" },
      { text: "Sub Category", value: "subCategoryName" },
      { text: "Delete", value: "actions", sortable: false },
    ],
    valid: true,
  }),
  watch: {
    propVendorCatListModel(value) {
      this.vendorCatListModel = value;
    },
    vendorCatListModel(value) {
      this.showTable = this.newData(value);
    },
    // Bind subcategory options
    categoryModel() {
      // Clear subcategory value
      this.subCategoryModel = 0;
      this.getSubcategory(this.categoryModel);
    },
    propUserName(value) {
      if (value) this.userName = value;
    },
    propVendorID(value) {
      if (value) this.vendorId = value;
    },
    propCheckStep(value) {
      if (value === 2) {
        if (this.showTable.length > 0) {
          this.$emit("EmitCategoryNext", true);
        } else {
          this.$notify({
            title: "Cann't goto next step!",
            text: "Please specify at least one categoire",
            type: "error",
          });
        }
      }
    },
  },
  mounted() {
    this.getCategory();
  },
  methods: {
    newData(data) {
      let result = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].isActive) {
          const element = {
            ...data[i],
          };
          result.push(element);
        }
      }
      return result;
    },
    async getCategory() {
      this.category = await masterservice.GetMasterCategory();
    },
    async getSubcategory(id) {
      this.subcategory = await masterservice.GetMasterSubCategory(id);
    },
    async AddVendorCat() {
      if (this.subCategoryModel != 0) {
        if (this.userName != "") {
          const depSubCate = this.vendorCatListModel.find(
            (element) => element.subCategoryId === this.subCategoryModel
          );
          if (depSubCate === undefined) {
            // not duplicate
            this.EmitPush();
          } else {
            // duplicate
            if (depSubCate.isActive === false) {
              // update duplicate;
              this.$emit("EmitCategory", {
                TypeEvent: "update",
                model: null,
                categoryId: depSubCate.categoryId,
                subCategoryId: depSubCate.subCategoryId,
              });
            } else {
              this.$notify({
                title: "Cann't add category!",
                text: "Duplicate Categoire",
                type: "error",
              });
            }
          }
        } else {
          this.$notify({
            title: "Cann't add category!",
            text: "Please input TaxID before",
            type: "error",
          });
        }
      } else {
        this.$notify({
          title: "Cann't add category!",
          text: "Please select subcategory before",
          type: "error",
        });
      }
    },

    async deleteCategory({ categoryId, subCategoryId }) {
      this.$emit("EmitCategory", {
        TypeEvent: "delete",
        model: null,
        categoryId,
        subCategoryId,
      });
      //  }
    },
    async EmitPush() {
      const categorys = await this.category.find(
        (element) => element.id === this.categoryModel
      );
      const subCategorys = await this.subcategory.find(
        (element) => element.id === this.subCategoryModel
      );
      const model = {
        id: 0,
        vendorId: this.vendorId,
        userName: this.userName,
        categoryId: this.categoryModel,
        subCategoryId: this.subCategoryModel,
        categoryName: categorys.categoryName,
        subCategoryName: subCategorys.subCategoryName,
        isActive: true,
      };
      this.$emit("EmitCategory", { TypeEvent: "add", model });
      await this.$refs.form.reset();
    },
  },
};
</script>
